export const setLoadingStatus = (reducer) => {
    return {
        type: 'SET_LOADING_STATUS',
        payload: reducer
    }
}

export const editingInProgress = (status) => {
    return { 
        type: 'EDITING_IN_PROGRESS',
        status
    }
}




// WEBPACK FOOTER //
// ./src/actions/loaderAction.js